import { useMemo } from 'react';
import { TagType } from '@sib/api';
import { createUseAppTranslation } from '@sib/i18n';
import { z } from 'zod';
import {
  MESSAGE_BODY_MAX_LENGTH,
  MESSAGE_TITLE_MAX_LENGTH,
  OrganizationEmailFormField,
} from './organization-email-form.utils';

const useAppTranslation = createUseAppTranslation('organizations');

const emailContactsSchema = z.object({
  [TagType.Contact]: z.array(z.string()),
  [TagType.Employee]: z.array(z.string()),
});

/**
 * Returns the Zod validation schema for the organization email form.
 */
export const useOrganizationEmailFormSchema = () => {
  const { t } = useAppTranslation();

  return useMemo(
    () =>
      z.object({
        [OrganizationEmailFormField.Recipient]: emailContactsSchema.refine(
          data => Object.values(data).flat().length > 0,
          { message: t('validation.required') }
        ),
        [OrganizationEmailFormField.Title]: z
          .string()
          .min(1, { message: t('validation.required') })
          .max(MESSAGE_TITLE_MAX_LENGTH, {
            message: t('errors.validation.cantBeLonger', {
              fieldLabel: t(
                'components.organizationEmailForm.fields.title.label'
              ),
              maxLength: MESSAGE_TITLE_MAX_LENGTH,
            }),
          }),
        [OrganizationEmailFormField.Message]: z
          .string()
          .min(1, { message: t('validation.required') })
          .max(MESSAGE_BODY_MAX_LENGTH, {
            message: t('errors.validation.cantBeLonger', {
              fieldLabel: t(
                'components.organizationEmailForm.fields.message.label'
              ),
              maxLength: MESSAGE_BODY_MAX_LENGTH,
            }),
          }),
        [OrganizationEmailFormField.ThreadMembers]: emailContactsSchema,
        [OrganizationEmailFormField.ShouldCreateTask]: z.boolean(),
      }),
    [t]
  );
};
